import { ScoreType, Sector } from '@/domain/impact/impact.entity';
import { translate } from '@/ui/i18n';

export function prepareQuizPanelDescription(
  scoreType: ScoreType,
  sector: Sector,
) {
  if (scoreType === 'co2') {
    return {
      description: sector ? translate(`Quiz.${sector}-description`) : '',
      descriptionTootltip: sector ? translate(`Quiz.${sector}-info`) : '',
    };
  } else {
    return {
      description: undefined,
      descriptionTootltip: undefined,
    };
  }
}
